import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalityDto } from '../interfaces';
import { StreetByCountryIAddressDTO } from '../interfaces/addresses/dtos/street-by-country-dto.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AddressesService {
  private iAddressBaseURL: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iAddressBaseURL = config.iAddressBaseURL;
  }

  public fetchLocalities(): Observable<LocalityDto[]> {
    return this.http.get<LocalityDto[]>(`${this.iAddressBaseURL}/Municipalities`);
  }

  public fetchLocalityStreets(postalCodes: string[]): Observable<StreetByCountryIAddressDTO[]> {
    return this.http.post<StreetByCountryIAddressDTO[]>(`${this.iAddressBaseURL}/Streets/ByPostalCodes`, [...postalCodes]);
  }

  public fetchStreetNumbers(streetId: string): Observable<{ boxNumber: string; houseNumber: string; streetId: number }[]> {
    return this.http.get<{ boxNumber: string; houseNumber: string; streetId: number }[]>(`${this.iAddressBaseURL}/Streets/${streetId}/Addresses`);
  }
}
